<template>
    <div class="word-input">
        <v-keyword-item
            v-for="(sensitiveWord, index) in sensitiveWords"
            :key="sensitiveWord.id"
            :idx="index"
            :value="sensitiveWord.name"
            :mode="sensitiveWord.mode"
            :maxlength="20"
            @input="itemChange"
        />
        <!-- <v-icon
            v-tip:addSensitiveWordTip.hover
            :class="
                'add-sensitive-word add-sensitive-word__' +
                    (isAddSensitiveWordActive && editingNum == 0 ? 'active' : 'disable')
            "
            name="tag_add"
            @click="addSensitiveWord"
        /> -->
        <v-button
            v-tip:addSensitiveWordTip.hover
            type="link"
            kind="primary"
            :disabled="isAddSensitiveWordActive && editingNum == 0 ? false : true"
            @click="addSensitiveWord"
        >
            <v-icon remote name="basic_new_line" />添加
        </v-button>
        <span
            class="count-limit"
            :class="{'disabled': isAddSensitiveWordActive && editingNum == 0 ? false : true}"
        >（{{ sensitiveWords.length }}/{{ MAX_SENSITIVE_WORDS_NUM }}）</span>
        <v-tip
            ref="addSensitiveWordTip"
            placement="right"
        >
            <span>{{
                isAddSensitiveWordActive
                    ? editingNum == 0
                        ? '添加敏感词'
                        : '请提交当前编辑后再添加'
                    : '最多添加' + MAX_SENSITIVE_WORDS_NUM + '个敏感词，请先删除部分后再新建'
            }}</span>
        </v-tip>
    </div>
</template>

<script>
/* eslint-disable */

import { Icon } from 'vhtml-ui';
import KeywordItem from '../keyword-item';

const sprites = require.context('./assets/icons', false, /[^\.]+\.svg$/);
Icon.addSprites(sprites);
const MAX_SENSITIVE_WORDS_NUM = 100;
export default {
    name: 'WordInput',
    components: {
        VKeywordItem: KeywordItem
    },
    props: {
        value: {
            type: Array,
            default() {
                return [];
            }
        }
    },
    data() {
        const sensitiveWordIdActive = [];
        let i;
        for (i = 0; i < MAX_SENSITIVE_WORDS_NUM; i++) {
            sensitiveWordIdActive.push(false);
        }
        this.value.forEach(sensitiveWord => {
            sensitiveWordIdActive[sensitiveWord.id] = true;
        });
        /**
         * sensitiveWordIdActive记录敏感词id的占用，用来参考生成唯一id，
         * nextSensitiveWordId用来记录下一个可用的id，设置该值是为了提高效率
         * 2019-01-04
         * 敏感词编辑同一时间只有一个item处于编辑状态,设置一个参数editingNum为处于编辑item的数目
         */
        return {
            MAX_SENSITIVE_WORDS_NUM,
            sensitiveWords: this.value,
            sensitiveWordIdActive,
            nextSensitiveWordId: this.value.length < MAX_SENSITIVE_WORDS_NUM ? this.value.length : -1,
            editingNum: 0
        };
    },
    computed: {
        isAddSensitiveWordActive() {
            return this.sensitiveWords.length < MAX_SENSITIVE_WORDS_NUM;
        }
    },
    methods: {
        itemChange(type, idx, val) {
            switch (type) {
                case 'edit':
                    if (this.editingNum > 0) {
                        this.$message('请提交当前编辑后再编辑', 'error');
                        return;
                    }
                    this.editingNum++;
                    this.$emit('input', 'edit', idx);
                    break;
                case 'delete':
                    if (this.value[idx].mode == 'edit') this.editingNum--;
                    this.$emit('input', 'delete', idx);
                    break;
                case 'tick':
                    if (this.isSensitiveWordsRepeat(idx, val)) {
                        this.$message('不能保存重复敏感词', 'error');
                        return;
                    }
                    this.editingNum--;
                    this.$emit('input', 'done', idx, val);
                    break;
                default:
                    console.log('undefined type');
            }
        },
        addSensitiveWord() {
            if (this.sensitiveWords.length == MAX_SENSITIVE_WORDS_NUM) return;
            if (this.editingNum > 0) return;
            const id = this.getUinId();
            this.editingNum++;
            this.$emit('input', 'add', id);
        },
        getUinId() {
            const retId = this.nextSensitiveWordId;
            let i;
            this.sensitiveWordIdActive[retId] = true;
            this.nextSensitiveWordId++;
            if (
                this.nextSensitiveWordId == MAX_SENSITIVE_WORDS_NUM ||
                this.sensitiveWordIdActive[this.nextSensitiveWordId]
            ) {
                if (this.sensitiveWords.length + 1 == MAX_SENSITIVE_WORDS_NUM) {
                    this.nextSensitiveWordId = -1;
                } else {
                    for (i = 0; i < this.sensitiveWordIdActive.length; i++) {
                        if (!this.sensitiveWordIdActive[i]) {
                            this.nextSensitiveWordId = i;
                            break;
                        }
                    }
                }
            }
            return retId;
        },
        isSensitiveWordsRepeat(idx, val) {
            let i;
            for (i = 0; i < this.value.length; i++) {
                if (idx == i) continue;
                if (val == this.value[i].name) return true;
            }
            return false;
        }
    }
};
</script>

<style lang="less">
@import '~@/common/common.less';

.word-input {
    overflow: hidden;

    .count-limit {
        color: #3856db;
        &.disabled {
            color: rgba(6,21,66,.4);
        }
    }

    .add-sensitive-word {
        color: @mainLightGray;
        width: 24px;
        height: 24px;
        margin-bottom: 10px;
        // float: left;
    }
    .add-sensitive-word__active {
        cursor: pointer;
        &:hover {
            color: @mainDeepGray;
        }
    }
    .add-sensitive-word__disable {
        opacity: 0.38;
    }
}
</style>
